export enum PaymentType {
  Both = 1,
  PayableOnly = 2,
  ReceivableOnly = 3,
}
